import React, { JSX } from "react";

export type PopoverTriggerProps = {
  className?: string;
  children: React.ReactElement<JSX.Element> | React.ReactElement<JSX.Element>[];
};

export default function PopoverTrigger({ children }: PopoverTriggerProps): JSX.Element {
  return <>{children}</>;
}
